"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initApollo = void 0;
var _client = require("@apollo/client");
var _env = _interopRequireDefault(require("../env"));
var _currentVersion = require("../currentVersion");
var _isSsr = require("../isSsr");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var client = null;
var getUri = function getUri(props) {
  var _props$graphqlUrl;
  var baseUrl = (_props$graphqlUrl = props.graphqlUrl) !== null && _props$graphqlUrl !== void 0 ? _props$graphqlUrl : _env["default"].getGraphqlUrl();
  if ((0, _isSsr.isSsr)()) {
    return baseUrl;
  }
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var publisherId = urlParams.get('publisherId');
  return !publisherId ? baseUrl : "".concat(baseUrl, "?publisherId=").concat(publisherId);
};
var initApollo = exports.initApollo = function initApollo() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!client) {
    client = new _client.ApolloClient({
      cache: new _client.InMemoryCache(),
      link: (0, _client.createHttpLink)({
        uri: getUri(props),
        credentials: 'include',
        headers: {
          'X-OLXBR-appVersion': _currentVersion.versionWithPlatform
        }
      })
    });
  }
  return client;
};